import React, { useState } from "react";

import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import WebhookExecutionErrorMessageDialog from "./webhook-execution-error-message-dialog";

import VisibilityIcon from '@mui/icons-material/Visibility';

const initalState = {
	openErrorMessageDialog: false,
}

export default function WebhookExecutionErrorMessage(props) {
	const { deliverystatus, errorMessage, intl } = props;

	const [internalState, setInternalState] = useState(initalState);

	function handleOpenOrClose() {
		setInternalState((prev) => ({ ...prev, openErrorMessageDialog: !prev?.openErrorMessageDialog }))
	}

	if (!errorMessage) {
		return (
			<span >
				{deliverystatus}
			</span>
		)
	}

	return (
		<React.Fragment>
			<Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
				<span>
					{deliverystatus}
				</span>

				<Tooltip title={intl.formatMessage({ id: "webhook.execution.report.view.informations.error.message" })}>
					<IconButton aria-label="details" size="small" onClick={handleOpenOrClose} color="error">
						<VisibilityIcon fontSize="small" />
					</IconButton>
				</Tooltip>
			</Box>

			<WebhookExecutionErrorMessageDialog
				open={internalState?.openErrorMessageDialog}
				handleOpenOrClose={handleOpenOrClose}
				errorMessage={errorMessage}
			/>
		</React.Fragment>
	);
}